import { FiClock, FiCalendar, FiMessageSquare, FiX } from "react-icons/fi";
import { formatCurrency } from "../../utils/formatCurrency";

function formatFecha(fecha) {
    if (!fecha) return "-";
    const d = new Date(fecha);
    if (Number.isNaN(d.getTime())) return fecha;
    return d.toLocaleDateString("es-PE");
}

export default function AportesMetaModal({
                                             meta,
                                             aportes = [],
                                             loading = false,
                                             onClose,
                                         }) {
    return (
        <div className="modal-backdrop">
            <div className="modal-card large">
                <div className="modal-header">
                    <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FiClock size={20} />
                        Historial de aportes: {meta?.nombre}
                    </h3>

                    <button className="btn-secondary" type="button" onClick={onClose}>
                        <FiX size={16} />
                    </button>
                </div>

                {loading ? (
                    <p>Cargando historial...</p>
                ) : aportes.length === 0 ? (
                    <p>No hay aportes registrados para esta meta.</p>
                ) : (
                    <div className="table-wrap">
                        <table className="table-app">
                            <thead>
                            <tr>
                                <th>Fecha aporte</th>
                                <th>Monto</th>
                                <th>Observación</th>
                                <th>Fecha registro</th>
                            </tr>
                            </thead>
                            <tbody>
                            {aportes.map((aporte) => (
                                <tr key={aporte.idMetaAporte}>
                                    <td>
                                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                            <FiCalendar size={15} />
                                            {formatFecha(aporte.fechaAporte)}
                                        </div>
                                    </td>
                                    <td>{formatCurrency(aporte.monto)}</td>
                                    <td>
                                        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                            <FiMessageSquare size={15} />
                                            {aporte.observacion || "-"}
                                        </div>
                                    </td>
                                    <td>{formatFecha(aporte.fechaCrea)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}